export default __webpack_public_path__ + "static/media/filling_0.2cf92276.jpg";